import FlexSideDrawer from "designSystem/components/flex/FlexSideDrawer";
import page from "csi/page";
import { useStore } from "csi/state/hooks";
import { action } from "mobx";
import { observer } from "mobx-react-lite";
import React from "react";
import DataSetupContent from "./DataSetupContent";
import DataSetupNavigator from "./DataSetupNavigator";

export const DataSetupLayout = observer(() => {
	const { browserStore, localStore } = useStore();
	const { fullScreenLeftDrawerClosed, fullScreenLeftDrawerClosedInitially } = browserStore;

	const onToggleOpen = action((open: boolean) => {
		// when user interacts with left drawer, reset setting to force it closed
		localStore.dataSetup.navigationOpen = open;
		browserStore.fullScreenLeftDrawerClosed = false;
		browserStore.fullScreenLeftDrawerClosedInitially = false;
	});

	return (
		<FlexSideDrawer
			drawerNode={<DataSetupNavigator />}
			onToggleOpen={onToggleOpen}
			onTransition={page.resize}
			open={localStore.dataSetup.navigationOpen && !fullScreenLeftDrawerClosed && !fullScreenLeftDrawerClosedInitially}
		>
			<DataSetupContent />
		</FlexSideDrawer>
	);
});

export default DataSetupLayout;